import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IGeoCoordinate } from '../types';
import { IServerResponse } from '../types/server-response';
import { TipoUbigeoEnum } from '../utils/enums';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private urlUbigeo = `${environment.baseUrlAPIDWH}/ubigeo`;
  private urlEntidad = `${environment.baseUrlAPIDWH}/entidad`;
  private urlLocalPrograma = `${environment.baseUrlAPIDWH}/localPrograma`;
  private urlGeneral = `${environment.baseUrlAPIDWH}/general`;

  constructor(private http: HttpClient) { }

  getUbigeo = (data: { tipo: TipoUbigeoEnum, region?: string, provincia?: string }) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlUbigeo}/listar`, data);
  }

  getNivelAcademico = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listarnivel`);
  }

  getNivelAcademicoPrograma = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlLocalPrograma}/listarnivelprogramas`);
  }

  getModalidadEstudio = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listarmodalidad`);
  }

  getModalidadEstudioProgramas = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlLocalPrograma}/listarmodalidadprogramas`);
  }

  getPeriodosAcademicos = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listarperiodo`);
  }

  getTipoGestion = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listartipogestion`);
  }

  getRegimen = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listarregimendedicacion`);
  }

  getCondicionLaboral = () => {
    return this.http.get<IServerResponse<any[]>>(`${this.urlGeneral}/listarcondicionlaboral`);
  }

  getEntidades = (filters: any = {}) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/listar`, {
      page: 1,
      pageSize: 1000,
      order: 'asc',
      ...filters
    });
  }

  getListaEntidadesMatriculados = (filters: any = {}) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/listar-entidades-matricula`, {
      page: 1,
      pageSize: 1000,
      order: 'asc',
      ...filters
    });
  }

  getListaEntidadesIngresos = (filters: any = {}) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/listar-entidades-ingreso`, {
      page: 1,
      pageSize: 1000,
      order: 'asc',
      ...filters
    });
  }

  getListaEntidadesDocentes = (filters: any = {}) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/listar-entidades-docente`, {
      page: 1,
      pageSize: 1000,
      order: 'asc',
      ...filters
    });
  }

  getLocalesEntidad = (idEntidad: number, position: IGeoCoordinate) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/locales`, {
      idEntidad,
      ...(position ? { latitudUbicacion: position.lat, longitudUbicacion: position.lng } : {})
    });
  }

  getLocalesEntidadPrograma = (idEntidad: number, idPrograma: number, idProgramaDocumento: number, position: IGeoCoordinate) => {
    
    return this.http.post<IServerResponse<any[]>>(`${this.urlLocalPrograma}/listarLocales`, {
      idEntidad,
      idPrograma,
      idProgramaDocumento,
      ...(position ? { latitudUbicacion: position.lat, longitudUbicacion: position.lng } : {})
    });
  }

  getNivelAcademicoPorEntidad = (idEntidad: number) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlGeneral}/ListarNivelEducativoEntidad`, { idEntidad });
  }

  getModalidadEstudioPorEntidad = (idEntidad: number,idNivelAcademico: number) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlGeneral}/ListarModalidadEntidad`, { idEntidad,idNivelAcademico });
  }

  listarProgramasPorEntidad = (idEntidad: number[], nombreCine: string, soloMatriculado: boolean) => {
    return this.http.post<IServerResponse<any>>(
      `${this.urlGeneral}/ListarProgramasEntidadGrilla`, { idEntidad, nombreCine, soloMatriculado }
    );
  }  

  listarClasificacionCinePorEntidad = (idEntidad: number[], soloMatriculado: boolean) => {
    return this.http.post<IServerResponse<any>>(
      `${this.urlGeneral}/ListarClasificacionEntidadGrilla`, { idEntidad, soloMatriculado }
    );
  }

  getFechaCorte = (modulo?: string) => {
    return this.http.post<IServerResponse<any>>(`${this.urlGeneral}/FechaCorte?modulo=${modulo}`, {});
  };

}
